import React from 'react'
import classNames from 'classnames'
import { List, ListItem, Typography } from '@mui/material'
import { withStyles } from 'tss-react/mui'
import { matchValues, Period } from '@app/lib/MyEnergy/intervalValues'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
// @ts-ignore — Arrow is still untyped JS
import Arrow from '@app/components/Common/Arrow/Arrow'
import { IEnergies } from '@app/@types/myEnergy'
import styles from './EnergyTotals.style'

interface Props {
  classes: Record<string, string>,
  energies: IEnergies,
  periodSelector: Period,
  isMobile: boolean,
}

class EnergyTotals extends React.Component<Props> {
  render() {
    const {
      classes,
      energies,
      periodSelector,
      isMobile,
    } = this.props
    const comparison = energies.comparison[matchValues[periodSelector]]
    const consumption = energies.total.consumption[matchValues[periodSelector]]
    const payment = energies.total.payment[matchValues[periodSelector]]
    return (
      <Wrapper className={classes.root}>
        <List className={classNames(
          classes.list,
          !isMobile && classes.listDesktop,
        )}
        >
          <ListItem className={classes.topWrapper}>
            <Wrapper className={classes.item}>
              <Wrapper className={classNames(
                classes.itemWrapper,
                classes.itemWrapperGreen,
              )}
              >
                <Typography className={classes.info}>
                  {consumption}
                  {' '}
                  {I18n.t('my_energy.power_kwh')}
                </Typography>
              </Wrapper>
              <Typography className={classes.itemTitle}>Power consumption</Typography>
            </Wrapper>

            <Wrapper className={classes.item}>
              <Wrapper className={classNames(
                classes.itemWrapper,
                classes.itemWrapperRed,
              )}
              >

                <Wrapper className={classNames(
                  classes.info,
                  comparison && classes.infoArrows,
                )}
                >
                  <Arrow trend={comparison} />
                  <Typography>
                    {Math.round(Math.abs(comparison) * 100) / 100}
                    {' '}
                    {I18n.t('my_energy.power_kwh')}
                  </Typography>
                </Wrapper>
              </Wrapper>
              <Typography className={classes.itemTitle}>Comparison with the previous period</Typography>
            </Wrapper>
          </ListItem>

          <ListItem className={classes.item}>
            <Wrapper className={classNames(
              classes.itemWrapper,
              classes.itemWrapperBlue,
            )}
            >
              <Typography className={classes.info}>
                {payment}
                {' '}
                $
              </Typography>
            </Wrapper>
            <Typography className={classes.itemTitle}>Payment</Typography>
          </ListItem>
        </List>
      </Wrapper>
    )
  }
}

export default withStyles(EnergyTotals, styles as any) as unknown as React.ComponentType<Omit<Props, 'classes'>>
